import { bridgeNotify } from "./notifyBridge";

/**
 * Legacy helper — routes to the shared MUI Snackbar notify.
 * Prefer `useNotify().notify(message, severity)` inside React components.
 * Signature kept as (type, message) for old call sites.
 */
export const showToastMessage = (type, message) => {
  const severity = ["success", "error", "info", "warning"].includes(type)
    ? type
    : "info";
  bridgeNotify(message, severity);
};
